import React from 'react';
import PropTypes from 'prop-types';
//import { Divider } from 'material-ui';
import RaisedButton from 'material-ui/RaisedButton';
import TextField from 'material-ui/TextField';
import InputMask from 'react-input-mask';
import {FormattedDate} from 'react-intl';

class TechHistory extends React.PureComponent {
    constructor(props, context) {
        super(props, context);   

        this.loadHistory = this
            .loadHistory
            .bind(this); 

        this.onStartDateChange = this
            .onStartDateChange
            .bind(this); 

        this.onEndDateChange = this
            .onEndDateChange
            .bind(this); 

        this.onTechIdChange = this
            .onTechIdChange
            .bind(this); 

            this.isValidDate = this
            .isValidDate
            .bind(this); 
    }

    isValidDate(d) {
        return d instanceof Date && !isNaN(d);
    }

    onStartDateChange(e){
        const {workOrderActions} = this.props;
        workOrderActions.setTechHistoryStartDate(e.target.value);
    }

    onEndDateChange(e){
        const {workOrderActions} = this.props;
        workOrderActions.setTechHistoryEndDate(e.target.value);
    }

    onTechIdChange(e){        
        const {workOrderActions} = this.props;
        workOrderActions.setTechHistoryTechId(e.target.value);
    }

    loadHistory(){
        const {workOrderActions, techData} = this.props;
        const startDate = techData.getIn(['history','startDate']);
        const endDate = techData.getIn(['history','endDate']);
        const techId = techData.getIn(['history','techId']);
        if(startDate && endDate && techId){
           workOrderActions.getTechHistoryStarted(techId, startDate, endDate); 
        }        
    }

    render() {   
        const {
            techData
        } = this.props;
        const startDate = techData.getIn(['history','startDate']);
        const endDate = techData.getIn(['history','endDate']);
        const techId = techData.getIn(['history','techId']);

        const styles = {
            margin: {margin: '10px', padding: '0px'},
            label: {
                fontWeight: 'bold',
                padding: '5px'
            },
            displayValue: {
                padding: '5px'
            }
        };

        const startDateField = (
            <InputMask 
                label="Start Date"
                name="startDate"
                mask="99/99/99" 
                maskChar=" " 
                value={startDate}
                onChange={this.onStartDateChange}                
            />
        );

        const endDateField = (
            <InputMask
                label="End Date"             
                name="endDate"
                mask="99/99/99" 
                maskChar=" "
                value={endDate}
                onChange={this.onEndDateChange} 
            />
        );

        const techIdInputField = (
            <TextField
                className="wow-fst-input-container"
                value={techId}
                hintText="Tech Id"
                fullWidth={true}
                onChange={this.onTechIdChange}/>
                       
        );

        const loadHistoryButton = (
            <div className="row">
                <div className="col s12">
                    <RaisedButton
                        style={{
                        margin: '5px'
                    }}
                        id="wow-fst-get-history-button"
                        disabled={false}
                        fullWidth
                        label="Load History"
                        primary={true}
                        onTouchTap={this.loadHistory}/>
                </div>
            </div>
        );

        let isError = false;
        let techHistoryDetails = null;
        let hasDetails = false;
        const techHistory = techData.getIn(['techs', techId, 'history']);
        if(techHistory){
            isError = techHistory.get('isError');
            techHistoryDetails = techHistory.get('details');
            hasDetails = techHistoryDetails && techHistoryDetails.count() > 0;
        } 

        let pastOrders = null;
        if(hasDetails){
            pastOrders = techHistoryDetails.map((item, index) => {
                return (                        
                    <div key={'techHistoryItem_' + index}>
                        <div className="row">
                            <span style={styles.label}>Address:</span> 
                            <span style={styles.displayValue}>{item.get('destinationAddress')}</span>
                        </div>                    
                        <div className="row">
                            <span style={styles.label}>Date:</span> 
                            <span style={styles.displayValue}><FormattedDate value={item.get('scheduledDate')}/></span>
                            <span style={styles.displayValue}>{item.get('timeWindow')}</span>
                   
                        </div>
                        <div className="row">
                            <span style={styles.label}>WO#:</span>
                            <span style={styles.displayValue}> {item.get('workOrder')}</span> 
                            <span style={styles.label}>ServiceType:</span> 
                            <span style={styles.displayValue}>{item.get('serviceType')} / {item.get('serviceTypeDescription')}</span>                     
                        </div>
                        <div className="row">
                            <span style={styles.label}>Tech:</span>
                            <span style={styles.displayValue}>{item.get('tech')}</span>

                            <span style={styles.label}>Status:</span>
                            <span style={styles.displayValue}>{item.get('orderStatus')}</span>                 
                        </div>
                        <div className="row">
                            <span style={styles.label}>Solution: </span>
                            <span style={styles.displayValue}>{item.get('primarySolutionCode')}</span>
                        </div>
                        <br />                                                                
                    </div>
                );            
            });
        }       

        let errorDisplay = null;
        if(isError){
            errorDisplay = (
                <div className="row">
                    <div className="col s12">An error occurred while retrieving history</div>
                </div>
            );
        }

        let emptyDisplay = null;

        if(!hasDetails){
            emptyDisplay = (
                <div className="row">
                <div className="col s12">No Results Found </div>
            </div>
            );
        }

        return (
             <div style={styles.margin}>       
                <div className="row"> 
                    <div className="col s6">Start Date: {startDateField}</div>
                    <div className="col s6">End Date: {endDateField}</div>                 
                </div>
                <div className="row"> 
                    <div className="col s6">{techIdInputField}</div>
                    <div className="col s6">{loadHistoryButton}</div>
                </div>
                {emptyDisplay}    
                {errorDisplay} 
                {pastOrders}
             </div>     
        );
    }
}

TechHistory.propTypes = {
    techData: PropTypes.object,
    workOrderActions: PropTypes.object
};

export default TechHistory;



// WEBPACK FOOTER //
// ./src/components/tech/TechHistory.js